import React, { useRef } from 'react';
import { Icon } from '@doxyme/ui';
import { useProgress, PROGRESS_DEFAULT_RESET, } from '../../helpers/use-progress';
export const ProgressButton = ({ isLoading, hasError, progress, slowFactor = 1, reset = PROGRESS_DEFAULT_RESET, children, successLabel = 'Success', errorLabel = 'Error', ...rest }) => {
    const containerRef = useRef(null);
    const barRef = useRef(null);
    useProgress(isLoading, hasError, reset, slowFactor, progress, containerRef, barRef);
    return (<button {...rest} ref={containerRef} aria-busy={isLoading ?? undefined}>
      <span className="progress" aria-hidden="true">
        <span className="progress-inner" ref={barRef}/>
      </span>

      <span className="progress-content">
        <span className="progress-default">{children}</span>

        <span className="progress-success" role="img" aria-label={successLabel}>
          <Icon name="ok" className="icon ok" size="x-small"/>
        </span>

        <span className="progress-error" role="img" aria-label={errorLabel}>
          <Icon name="close-old" className="icon close" size="x-small"/>
        </span>
      </span>
    </button>);
};
